import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#rent-vs-buy-app', App);
